const timelineSchema = {
  title: 'Timeline item',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['datetime', 'title', 'description', 'icon', 'color'],
    },
  ],
  properties: {
    datetime: {
      title: 'Datum a čas',
      widget: 'datetime',
    },
    title: {
      title: 'Nadpis',
    },
    description: {
      title: 'Popis',
    },
    icon: {
      title: 'Ikona',
      description: (
        <>
          Podívejte se{' '}
          <a
            href="https://react.semantic-ui.com/elements/icon/"
            target="_blank"
            rel="noreferrer noopener"
          >
            sem
          </a>{' '}
          na seznam všech dostupných ikon
        </>
      ),
    },
    color: {
      title: 'Barva',
      defaultValue: 'blue',
      choices: [
        ['red', 'Red'],
        ['orange', 'Orange'],
        ['yellow', 'Yellow'],
        ['olive', 'Olive'],
        ['green', 'Green'],
        ['teal', 'Teal'],
        ['blue', 'Blue'],
        ['violet', 'Violet'],
        ['purple', 'Purple'],
        ['pink', 'Pink'],
        ['brown', 'Brown'],
        ['grey', 'Grey'],
        ['black', 'Black'],
      ],
    },
  },
  required: [],
};

export default {
  title: 'Timeline block',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['reversed', 'hideTime', 'items'],
    },
  ],

  properties: {
    reversed: {
      title: 'Pravo nalevo',
      type: 'boolean',
    },
    hideTime: {
      title: 'Schovat čas',
      type: 'boolean',
    },
    items: {
      title: 'Timeline items',
      widget: 'object_list',
      schema: timelineSchema,
    },
  },

  required: [],
};
